import { RootState } from "../store";
import { IWagonsCalendarState, Status } from "../types/state";
import { IWagonEvent, WagonsFilter } from "../types/wagonEvent";

export const getWagonsCalendar = (state: RootState): IWagonsCalendarState => state.wagonsCalendar;
export const getWagonsCalendarEvents = (state: RootState): IWagonEvent[] => state.wagonsCalendar.wagonEvents;
export const getWagonsCalendarFilter = (state: RootState): WagonsFilter => state.wagonsCalendar.filter;
export const getWagonsCalendarScrollTop = (state: RootState): number => state.wagonsCalendar.scrollTop;
export const getWagonsCalendarIsLoading = (state: RootState): boolean => state.wagonsCalendar.status !== Status.success;
